import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { createUser } from '../../../redux/User/actions';
import UserForm from './UserForm';
import { fetchCountries } from '../../../redux/Country/actions';

export const AddUser = () => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const countries = useSelector((state) => state.countries?.countries || []);

  useEffect(() => {
    dispatch(fetchCountries());
  }, [dispatch]);

  const showModal = () => {
    setVisible(true);
  };

  const hideModal_Ok = () => {
    form.submit();
  };

  const form_onfinish = (values) => {
    dispatch(createUser(values));
    form.resetFields();
    setVisible(false);
  };

  const hideModal_Cancel = () => {
    setVisible(false);
    form.resetFields();
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        + Créer
      </Button>
      <Modal
        title="Ajouter utilisateur"
        visible={visible}
        onOk={hideModal_Ok}
        onCancel={hideModal_Cancel}
        okText="Submit"
        cancelText="Fermer"
      >
        <UserForm form={form} initialValues={{}} showPassword={true} onFinish={form_onfinish} countries={countries} />
      </Modal>
    </>
  );
};

export default AddUser;
